import Flag from '@atlaskit/flag';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { defaultTo, get } from 'lodash';
import React from 'react';
// import ScreenEventAnalytics from '../../../../../common/analytics/components/screen-event-analytics';
// import { AnalyticsEventSource } from '../../../analytics/constants';
import { ChatRoomLink, ServiceDeskLink } from '../help-links';
import { appName } from '../../../app-name';
import { PanelTypeEnum } from '../constants';
import { ReportError } from '../error-reporting';
import '../shared.scss';
import './generic-error-page.scss';

const getErrorMessage = (props: { error: any }) => {
  const error = props?.error;
  const networkErrors = get(error, 'networkError.result.errors.0.message');
  const graphQlErrors = get(error, 'graphQLErrors.0.message');
  return networkErrors || defaultTo(graphQlErrors, error?.message);
};

const defaultDescription = (
  <p>
    Please consult the {appName} team via the <ChatRoomLink /> or <ServiceDeskLink /> for assistance.
  </p>
);

export const GenericErrorPage = (props: {
  error: any;
  title?: string;
  description?: React.ReactNode;
  shouldHideErrorMsg?: boolean;
  enableReporting?: boolean;
  enableTicketCreationOption?: boolean;
}) => {
  const { enableReporting = false, enableTicketCreationOption = false } = props;
  return (
    <div className="error-flag" data-testid="generic-error-page">
      {/* <ScreenEventAnalytics
                event={{
                    name: AnalyticsEventSource.ERROR_SCREEN
                }}
            /> */}
      <div className="error-report-container">
        <Flag
          title={props?.title ?? 'We encountered a problem with your request'}
          description={
            <>
              {props.description ?? <>{defaultDescription}</>}
              {props.shouldHideErrorMsg || (
                <p>
                  <code>{getErrorMessage(props)}</code>
                </p>
              )}
            </>
          }
          appearance="normal"
          id="error-flag"
          icon={<WarningIcon label="Error" />}
        />
        {enableReporting && (
          <ReportError
            errorMessage={
              props.error
                ? props.error.message
                : 'Please consult the team via the help channel or service desk for assistance.'
            }
            type={PanelTypeEnum.ERROR_PANEL}
            enableTicketCreationOption={enableTicketCreationOption}
          />
        )}
      </div>
    </div>
  );
};
